import { ModalButtonProps } from './modal/modal.interfaces';
import Modal from './modal/modalComponent';

interface InactivityModalProps {
  inactivityModalOpen: boolean;
  title: string;
  message: string;
  timerMessage: string;
  remainingTime: string;
  continueMessage: string;
  buttons: ModalButtonProps[];
  onClose: () => void;
}

const InactivityModal: React.FC<InactivityModalProps> = ({
  inactivityModalOpen,
  title,
  message,
  remainingTime,
  continueMessage,
  buttons,
  onClose,
}) => {
  return (
    <Modal
      isOpen={inactivityModalOpen}
      title={title}
      modalDesktopWidth="desktop:max-w-[600px]"
      buttons={buttons}
      onClose={onClose}
      enableOverlapOfModals={true}
    >
      <div className="flex flex-col desktop:flex-row p-5 desktop:py-3 px-5 gap-4 bg-white rounded-lg">
        <div className="flex flex-col justify-center">
          <p className="text-base font-medium text-med-gray-3">{message}</p>
          <p className="text-h1 font-semibold text-neutral-800 mx-auto">
            {remainingTime}
          </p>
        </div>
      </div>
      <p className="text-h5 ml-auto mr-auto font-normal text-med-dark">
        {continueMessage}
      </p>
    </Modal>
  );
};

export default InactivityModal;
